<template>
    <div class="section">
        <div class="anchor" id="music"></div>
        <div class="sec-box sec-music">
            <img src="@/assets/images/title_pc.png" alt="" class="title off-1024">
            <img src="@/assets/images/title_sp.png" alt="" class="title on-1024">
            <img src="@/assets/images/wave_01.jpg" alt="" class="wave">
            <div class="box-swiper">
                <swiper :options="swiperOption" ref="mySwiper">
                    <swiper-slide><img class="off-1024" src="@/assets/images/kv_pc_01.jpg" alt=""><img src="@/assets/images/kv_sp_01.jpg" alt="" class="on-1024"></swiper-slide>
                    <swiper-slide><img class="off-1024" src="@/assets/images/kv_pc_03.jpg" alt=""><img src="@/assets/images/kv_sp_03.jpg" alt="" class="on-1024"></swiper-slide>
                    <swiper-slide><img class="off-1024" src="@/assets/images/kv_pc_02.jpg" alt=""><img src="@/assets/images/kv_sp_02.jpg" alt="" class="on-1024"></swiper-slide>
                    <swiper-slide><img class="off-1024" src="@/assets/images/kv_pc_04.jpg" alt=""><img src="@/assets/images/kv_sp_04.jpg" alt="" class="on-1024"></swiper-slide>
                    <swiper-slide><img class="off-1024" src="@/assets/images/kv_pc_05.jpg" alt=""><img src="@/assets/images/kv_sp_05.jpg" alt="" class="on-1024"></swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>
        </div>
        <div class="go-down">SCROLL DOWN</div>
    </div>
</template>

<script>
export default {
    name: "SecMusic",
    data() {
        return {
            swiperOption: {
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'progressbar',
                },
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: true,
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../styles/components/variable.scss";
.sec-music {
    padding: 40px 0 57px 0;
}

.box-swiper {
    width: 784px;
    max-width: 100%;
    height: 472px;
    color: #FFF;
    margin-left: 380px;
    position: relative;
    // z-index: 1;
}

.swiper-pagination {
    top: auto !important;
    bottom: 0 !important;
}

.sec-music {
    position: relative;
    // height: 200px;

    .title, .wave {
        position: absolute;
    }

    .title {
        height: auto;
        top: 123px;
        left: 36px;
        z-index: 2;
        margin-left: 0;
    }

    .wave {
        top: 90px;
        left: 170px;
    }

}

.swiper-slide {
    img {
        max-width: 100%;
    }
}



@media all and (max-width: 1024px) {

.sec-music {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    padding: 0;
    
    .title {
        position: absolute !important;
        max-width: 50%;
        top: 11%;
        left: 4%;
        margin-left: 0 !important;
    }

    .wave {
        max-width: 40%;
        top: 18%;
        left: 12%;
    }
}

.box-swiper {
    max-width: 67%;
    height: auto;
    margin-left: 0;
    margin-right: 6%;
}





}
</style>